import { render, staticRenderFns } from "./Picto.vue?vue&type=template&id=20333102&scoped=true&"
import script from "./Picto.vue?vue&type=script&lang=js&"
export * from "./Picto.vue?vue&type=script&lang=js&"
import style0 from "./Picto.vue?vue&type=style&index=0&id=20333102&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20333102",
  null
  
)

export default component.exports